var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('Header'),_c('Payments',{staticClass:"Home-Payments"}),_c('Games',{staticClass:"Home-Games"}),_c('About',{staticClass:"Home-About"}),_c('Footer',{staticClass:"Home-Footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }